import { restApiClient } from '@/datasources';
import { AuthenticatedUser, BasicAuthenticatedUser } from '@/types/auth-base.types';

export async function getAuthenticadUser(accessToken: string) {
  const { data } = await restApiClient.get<AuthenticatedUser>('online/customers/me', undefined, {
    headers: { Authorization: `Bearer ${accessToken}` },
  });
  return data;
}

export async function getBasicAuthenticatedUser(accessToken: string) {
  const { data } = await restApiClient.get<BasicAuthenticatedUser>('public/user/me', undefined, {
    headers: { Authorization: `Bearer ${accessToken}` },
  });
  const customerUser: AuthenticatedUser = {
    id: data.userId,
    documentNumber: data.documentNumber,
    socialName: '',
    legalName: data.fullName,
    birthday: '',
    gender: undefined,
    address: {
      zipcode: '',
      addressLine1: '',
      addressLine2: '',
      number: '',
      neighborhood: '',
      city: '',
      state: '',
    },
    contact: {
      phones: [],
      email: data.email,
    },
    termVersion: data.termVersions?.find((term) => term.type === 'online'),
  };

  return customerUser;
}

export type LoadedAuthenticatedUser = {
  user: AuthenticatedUser;
  isBasicProfile: boolean;
};

const loadAuthenticatedUser = async (accessToken: string): Promise<LoadedAuthenticatedUser> => {
  try {
    return { user: await getAuthenticadUser(accessToken), isBasicProfile: false };
  } catch {
    return { user: await getBasicAuthenticatedUser(accessToken), isBasicProfile: true };
  }
};

export async function tryToLoadAuthenticatedUser(accessToken: string) {
  if (!accessToken) {
    return;
  }
  return await loadAuthenticatedUser(accessToken);
}
